"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanitizeAddressKey = exports.sanitizeAddressKeySuffix = void 0;
const class_transformer_1 = require("class-transformer");
// If you update this, also check the regex in IsAddressKey
const SPECIAL_CHARS_TO_IGNORE = /[\!\@\#\$\%\^\&\*\)\(\+\=\.\,\_\-\/\ \\\']/g;
const sanitizeAddressKeySuffix = (value) => {
    if (value === undefined || value === null) {
        return value;
    }
    const split = value.split('_');
    const suffix = split.slice(2).join('');
    if (!suffix) {
        return value;
    }
    const replaced = suffix.replaceAll(SPECIAL_CHARS_TO_IGNORE, '');
    return `${split[0]}_${split[1]}_${replaced}`;
};
exports.sanitizeAddressKeySuffix = sanitizeAddressKeySuffix;
const sanitizeAddressKeySuffixAnnotation = ({ value }) => (0, exports.sanitizeAddressKeySuffix)(value);
/**
 * Maps a given address key to ignore special characters in the suffix.
 * This mapper assumes that IsAddressKey has already validated the value.
 * The main driver behind this mapping is that addresses exist in UPS without any special characters
 *
 * @example
 * class Example {
 *   @TransformAddressKey()
 *   public property: string;
 * }
 *
 * const example = new Example();
 * example.property = '1234AB_12_A'; // not transformed
 * example.property = '1234AB_12_ba-3'; // transformed to '1234AB_12_ba3'
 * NOTE that this may cause collisions. If addresses exist like '1234AB_12_ba-3' and '1234AB_12_b-a3' they will both end up as '1234AB_12_ba3'
 */
const SanitizeAddressKey = () => (target, key) => (0, class_transformer_1.Transform)(sanitizeAddressKeySuffixAnnotation)(target, key);
exports.SanitizeAddressKey = SanitizeAddressKey;
